import { useLayoutEffect } from "react";
import { setTitle } from "@/helpers/window.helpers";

/**
 * Set the window title
 */
const useTitle = (title = "") => {
  useLayoutEffect(() => {
    setTitle(title);
  }, [title]);
};

export default useTitle;
